/** Where every "See all" in this block goes — there are three of them. */
export const SEE_ALL_HREF = '/investment-opportunities';

/**
 * The rails sit under this block's own `h2`, so their headings are one level
 * deeper than on /investment-opportunities, where the page title is the `h1`.
 */
export const RAIL_HEADING_LEVEL = 'h3' as const;

/**
 * The section `Container`'s horizontal padding. `4` is Chakra's `Container`
 * default, which is what every other homepage section uses — so the block's
 * headings land on the same left margin as "What's new" above it.
 */
export const SECTION_PADDING_X = '4';

/**
 * What the rails need to cancel `SECTION_PADDING_X` — see `ICardRailProps.bleed`
 * for the two rules. `CardRail`'s defaults are calibrated to
 * /investment-opportunities' wider container instead, so both rails here have to
 * be told.
 *
 * Only below `sm`. There the bleed is the point: the rail runs to the viewport
 * edge and the gutter stays narrower than it, and that difference is the
 * next-card peek the design shows 8px of. From `sm` up the rails are cancelled
 * back to zero so they end on the section `Container`'s content edge — the same
 * line the block's heading, the rail headings and the full-width "See all" end
 * on. Left bleeding, the slides would overhang every one of them by
 * `SECTION_PADDING_X`, which reads as a misalignment rather than as a rail that
 * continues.
 */
export const SECTION_RAIL_BLEED = { base: `-${SECTION_PADDING_X}`, sm: '0' };
export const SECTION_RAIL_GUTTER = { base: '2', sm: '0' };
